const teachers = {
  teachers: "Teachers",
  welcomeTeacherPersonalHome: "Welcome to your dashboard",
  teacherNotSubscribedMessage:
    "This feature requires at least 10 subscribed students.",
  teacher: "Teacher",
  teacherDetail: "Teacher details",
  teacherNotActivated: "This teacher has not subscribed yet.",
  teacherWithColon: "Teacher: ",
  teacherNoGradingSystem:
    "Before creating an assignment, please select the grading system you would like to use.",
  frenchGradingSystemLabel: "French grading system (/20)",
  germanGradingSystemLabel: "German grading system (/6))",
  selectGradingSystemTitle: "Select a grading system",
  selectGradingSystemDescription:
    "You are about to select the {gradingSystem} grading system for your account. This grading system will apply for the entire school year.",
};

export default teachers;
